module.exports = __webpack_public_path__ + "static/media/h320_16.f366fcc397ae5542810e8c2b55701de4.png";